// @flow
import * as React from 'react';
import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";

import Navbar from "../../Layouts/Navbar";
import Header from "../../Layouts/Header";
import {useParams} from "react-router-dom";
import {useNavigate} from "react-router-dom";

const currencyFormat = Intl.NumberFormat('en-US');
export default function ReagentVendors(props) {
    const navigate = useNavigate();
    const { id } = useParams();
    const [isLoaded, setIsLoaded] = React.useState(false);
    const [vendors, setVendors] = React.useState([]);

    React.useEffect(() => {
        window.localStorage.removeItem("fromSearch");
        const params = {

        }

        API.getVendorReagents(params)
            .then((response) => {
                setVendors(response.data);
                setIsLoaded(true);
            })
            .catch((error) => {
                if(error.response) {
                    toast.error(error.response.data.message);
                }
                else {
                    toast.error(error.message);
                }
            });
        setTimeout(() => {
            window.scrollTo({top: 0, behavior: 'smooth'});
        }, 400)
    }, [id]);
    return (
        <React.Fragment>
            <Toast />
            {
                !isLoaded && <Loading />
            }
            <Header title='لیست فروشندگان' hasBack={true} />

            {/* Servitor */}
            <section className="container-fluid mb-5  mt-3 py-5 rtl px-0  ">

                <div className="row mx-3">
                    {
                        vendors.map (vendor => {
                            return (
                                <div className="col-12 p-3 py-1" key={vendor.id}
                                     onClick={
                                         () => {
                                             navigate(`/vendor/${vendor.id}`);
                                         }
                                     }
                                >
                                    <div className="vendor-container row p-2 ">
                                        <div className="col-2 vendor-image p-0 ">
                                            <img src={vendor.image} alt={vendor.title} className='w-100' />
                                        </div>
                                        <div className="col-10 ">
                                            <div className="title py-2 pe-2 text-end">
                                                {vendor.title}
                                            </div>
                                            <div className="description pe-2 ">


                                            </div>
                                        </div>
                                        <div className="col-7 text-small-3 pt-2">

                                             فاکتور تحویل شده ماه جاری


                                        </div>
                                        <div className="col-5 text-small-1 fw-bold text-start  pt-2 text-primary-color">
                                            {
                                                vendor.is_marketer ?
                                                    currencyFormat.format(vendor.sum) : '****'
                                            }
                                            &nbsp;
                                            ریال
                                        </div>
                                        <div className="col-7 mt-2 text-small-3 pt-2">

                                             فاکتور تحویل شده ماه گذشته


                                        </div>
                                        <div className="col-5 mt-2 text-small-2 fw-bold text-start  pt-2 text-primary-color">
                                            {
                                                vendor.is_marketer ?
                                                    currencyFormat.format(vendor.sum_last_month) : '****'
                                            }
                                            &nbsp;
                                            ریال
                                        </div>

                                    </div>
                                </div>
                            )} )

                    }
                </div>
            </section>

            <Navbar />
        </React.Fragment>
    );
};
